import "./index.scss";

import ReactDOM from "react-dom/client";
import Routers from "router";
import { AppProvider, SessionProvider, ThemeProvider } from "contexts";
import { ThemeProvider as MUIThemeProvider } from "@mui/material/styles";
import { Themes } from "utils";
import { Light } from "themes";
import { HealthCheck } from "middlewares";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <AppProvider initLocale={"EN"}>
    <ThemeProvider initTheme={Light}>
      <MUIThemeProvider theme={Themes.defaultTheme(Light)}>
        <SessionProvider>
          <HealthCheck>
            <Routers />
          </HealthCheck>
        </SessionProvider>
      </MUIThemeProvider>
    </ThemeProvider>
  </AppProvider>
);
